export default "__VITE_ASSET__EtqFHgIB__";